"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.treatedTypeMessages = exports.hcvTreatedEverMessages = exports.hcvCurrentStateMessages = exports.TreatedType = exports.HcvTreatedEver = exports.HcvCurrentState = void 0;
const schema_1 = require("../../../../../schema");
var HcvCurrentState;
(function (HcvCurrentState) {
    HcvCurrentState["PCR_NEGATIVE"] = "PCR_negative";
    HcvCurrentState["PCR_POSITIVE"] = "PCR_positive";
    HcvCurrentState["UNKNOWN"] = "UNKNOWN";
})(HcvCurrentState || (exports.HcvCurrentState = HcvCurrentState = {}));
var HcvTreatedEver;
(function (HcvTreatedEver) {
    HcvTreatedEver["YES"] = "YES";
    HcvTreatedEver["NO"] = "NO";
    HcvTreatedEver["UNKNOWN"] = "UNKNOWN";
})(HcvTreatedEver || (exports.HcvTreatedEver = HcvTreatedEver = {}));
var TreatedType;
(function (TreatedType) {
    TreatedType["DAA"] = "DAA";
    TreatedType["INTERFERON"] = "INTERFERON";
    TreatedType["OTHER"] = "OTHER";
})(TreatedType || (exports.TreatedType = TreatedType = {}));
exports.hcvCurrentStateMessages = {
    [HcvCurrentState.PCR_NEGATIVE]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvCurrentState.PCR_NEGATIVE",
        defaultMessage: "PCR Negatív"
    },
    [HcvCurrentState.PCR_POSITIVE]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvCurrentState.PCR_POSITIVE",
        defaultMessage: "PCR Pozitív"
    },
    [HcvCurrentState.UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvCurrentState.UNKNOWN",
        defaultMessage: "Ismeretlen"
    }
};
exports.hcvTreatedEverMessages = {
    [HcvTreatedEver.YES]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvTreatedEver.YES",
        defaultMessage: "Igen"
    },
    [HcvTreatedEver.NO]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvTreatedEver.NO",
        defaultMessage: "Nem"
    },
    [HcvTreatedEver.UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.hcvTreatedEver.UNKNOWN",
        defaultMessage: "Ismeretlen"
    }
};
exports.treatedTypeMessages = {
    [TreatedType.DAA]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.treatedType.DAA",
        defaultMessage: "DAA"
    },
    [TreatedType.INTERFERON]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.treatedType.INTERFERON",
        defaultMessage: "Interferon"
    },
    [TreatedType.OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.chronicLiverFailure.chronicLiverFailureHcv.treatedType.OTHER",
        defaultMessage: "Egyéb"
    }
};
const hcvCurrentState = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HcvCurrentState.PCR_NEGATIVE).interpretation({
        vocab: "ktx",
        code: "HCV_status_PCR_negative"
    }),
    schema_1.Schema.singleChoiceItem(HcvCurrentState.PCR_POSITIVE).interpretation({
        vocab: "ktx",
        code: "HCV_status_PCR_positive"
    }),
    schema_1.Schema.singleChoiceItem(HcvCurrentState.UNKNOWN).interpretation({
        vocab: "ktx",
        code: "HCV_status_unknown"
    })
]);
const hcvTreatedEver = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HcvTreatedEver.YES),
    schema_1.Schema.singleChoiceItem(HcvTreatedEver.NO),
    schema_1.Schema.singleChoiceItem(HcvTreatedEver.UNKNOWN)
]);
const treatedType = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hcvTreatedEver} ==="YES"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(TreatedType.DAA),
    schema_1.Schema.multiChoiceItem(TreatedType.INTERFERON),
    schema_1.Schema.multiChoiceItem(TreatedType.OTHER)
]));
const hcvTreatedComment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    hcvCurrentState,
    hcvTreatedEver,
    treatedType,
    hcvTreatedComment
})
    .interpretation({
    vocab: "ktx",
    code: "hcv_chronic_liver_failure_statement"
})
    .tag({ vocab: "fyrms", code: "action" });
